import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DarkThemeSwitch } from 'app/dark-theme-switch';
import { bumpIn } from '../animations';
import { DeviceDetection } from '../device-detection.helper';

@Component({
	selector: 'app-nav-button',
	templateUrl: './nav-button.component.html',
	styleUrls: ['./nav-button.component.scss'],
	host: {
		'[class.selected]': 'selected',
	},
	animations: [bumpIn],
})
export class NavButtonComponent {
	@Input() icon = 'school';
	@Input() content = '';
	@Input() selected = false;

	@Output() onClick: EventEmitter<boolean> = new EventEmitter();

	constructor(public darkTheme: DarkThemeSwitch) {}

	get isMobile() {
		return DeviceDetection.isMobile();
	}

	doClick() {
		this.onClick.emit(this.selected);
	}
}
